var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.25 218.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#dfd7cd;}.c{fill:#da783c;}.d{stroke-width:3.78px;}.d,.e,.f{fill:none;stroke:#dfd7cd;stroke-miterlimit:10;}.e{stroke-width:9.77px;}.f{stroke-width:2.41px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 109.12,
    cy: 109.12,
    r: 109.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M179.57,102.59v63.12c0,4.47-3.62,8.09-8.09,8.09H54.08c-4.47,0-8.09-3.62-8.09-8.09v-63.12c0-4.47,3.62-8.09,8.09-8.09h33.45v-18.38c0-2.88,2.34-5.22,5.22-5.22h40.46c2.88,0,5.22,2.34,5.22,5.22v18.38h33.06c4.47,0,8.09,3.62,8.09,8.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 112.78,
    cy: 132.5,
    r: 27.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 152.67,
    cy: 110.08,
    r: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 54.25,
    y: 80.58,
    width: 20.3,
    height: 13.69,
    rx: 5.44,
    ry: 5.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 37.73,
    y: 44.23,
    width: 2.83,
    height: 34.46,
    rx: 1.42,
    ry: 1.42,
    transform: "translate(-31.99 45.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 54.02,
    y: 35.97,
    width: 2.83,
    height: 34.46,
    rx: 1.42,
    ry: 1.42,
    transform: "translate(-11.9 16.19) rotate(-15.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 71.95,
    y: 35.97,
    width: 2.83,
    height: 34.46,
    rx: 1.42,
    ry: 1.42,
    transform: "translate(16.37 -17.26) rotate(15.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 87.06,
    y: 44,
    width: 2.83,
    height: 34.46,
    rx: 1.42,
    ry: 1.42,
    transform: "translate(69.21 -44.63) rotate(45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePhoto);
export default __webpack_public_path__ + "static/media/make-photo.63325adb832e455a6df7bc15107beb01.svg";
export { ForwardRef as ReactComponent };